import { Component, ElementRef } from '@angular/core';
import * as $ from 'jquery';

@Component({
    selector: 'toast-notification',
    templateUrl: 'toast-notification.component.html',
    styleUrls: ['toast-notification.component.css'],
    standalone: false
})
export class ToastNotificationComponent {
    constructor(private el: ElementRef) { }

    message: string = '';
    duration: number = 3000;
    type: 'success' | 'error' = 'success';

    showToast(message: string, duration: number, type: 'success' | 'error'): void {
        this.message = message;
        this.duration = duration;
        this.type = type;

        $(this.el.nativeElement).find('.toast-note').removeClass('hide').addClass('show');

        setTimeout(() => {
            $(this.el.nativeElement).find('.toast-note').removeClass('show').addClass('hide');
        }, this.duration);
    }

    protected hideToast(): void {
        $(this.el.nativeElement).find('.toast-note').removeClass('show').addClass('hide');
    }
}
